import MuiDialogTitle from '@mui/material/DialogTitle';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogTitle = styled(MuiDialogTitle)<Props>`
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  padding: 0 32px;
`;

export default DialogTitle;
